


import Formulario from '../../components/formulariocerrado/componentecerrado'
import React, { useEffect, useState } from "react";


export default function Paginas() {
  


   
            return (
                <>
           
              <div  >
        <br/>
                <Formulario/>
                
                </div>
              
     
                
          
                </>
           
            );
        
        }